import { render, staticRenderFns } from "./water-quality-detail.vue?vue&type=template&id=7ae1a8fa&scoped=true"
import script from "./water-quality-detail.vue?vue&type=script&lang=js"
export * from "./water-quality-detail.vue?vue&type=script&lang=js"
import style0 from "./water-quality-detail.vue?vue&type=style&index=0&id=7ae1a8fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae1a8fa",
  null
  
)

export default component.exports